import { IChildrenProp, IDiv } from 'types/components/components.interface';
import './LabeledValue.scss';

interface ILabeledValueProps extends IChildrenProp, IDiv {
  separator?: string;
  label: string;
  empty?: string;
}

const LabeledValue = ({
  children,
  label,
  separator = ':',
  className = '',
  empty = '-',
  ...props
}: ILabeledValueProps) => {
  return (
    <div className='labeled-value'>
      <div className='label'>
        {label}
        {separator}
      </div>
      <div {...props} className={`value ${className}`}>
        {!!children?.toString().length ? children : empty}
      </div>
    </div>
  );
};

export default LabeledValue;
